import { debugLog, debugError, debugWarn, debugTable, debugGroup, debugGroupEnd } from '../utils/debugUtils';
class ScoreMarker {
    constructor(teamId, markerCardSuit = 'oros', markerCardValue = 8) {
        this.teamId = teamId; // 1 or 2
        this.score = 0; // 0-18
        this.markerCardSuit = markerCardSuit; // Always 'oros'
        this.markerCardValue = markerCardValue; // 8 or 9
        this.onWin = null; // Callback when team reaches 18 points
        this.onWin = null; // Callback when team reaches 18 points
        this.onScoreChange = null; // Callback when score changes
        this.hasWonGame = false;

        this.history = []; // History of score events

        // Functions to add/subtract points from console
        window.addPointsTeam1 = (points = 1) => {
            this.addPoints(points);
            this.addHistoryEntry('Debug', 'Console', points);
            debugLog(`✅ Team 1: +${points} pts | Total: ${this.score} pts (${this.isInMalas() ? 'malas' : 'buenas'})`);
        };

        window.subtractPointsTeam1 = (points = 1) => {
            this.subtractPoints(points);
            debugLog(`❌ Team 1: -${points} pts | Total: ${this.score} pts (${this.isInMalas() ? 'malas' : 'buenas'})`);
        };

        window.addPointsTeam2 = (points = 1) => {
            this.addPoints(points);
            this.addHistoryEntry('Debug', 'Console', points);
            debugLog(`✅ Team 2: +${points} pts | Total: ${this.score} pts (${this.isInMalas() ? 'malas' : 'buenas'})`);
        };

        window.subtractPointsTeam2 = (points = 1) => {
            this.subtractPoints(points);
            debugLog(`❌ Team 2: -${points} pts | Total: ${this.score} pts (${this.isInMalas() ? 'malas' : 'buenas'})`);
        };
    }

    /**
     * Add a generic entry to the history
     * @param {string} type - Event type (e.g., 'Ronda', 'Caída')
     * @param {string} actor - Who triggered it (e.g., 'Jugador', 'Pareja Rival')
     * @param {number} points - Points added
     * @param {number} handNumber - Optional hand number
     */
    addHistoryEntry(type, actor, points, handNumber = '-') {
        this.history.push({
            hand: handNumber,
            type: type,
            actor: actor,
            points: points,
            timestamp: Date.now()
        });
        debugLog(`📝 History added for Team ${this.teamId}:`, { handNumber, type, actor, points });
    }

    getHistory() {
        return this.history;
    }

    /**
     * Restore history from saved state
     * @param {Array} history - Saved history array
     */
    restoreHistory(history) {
        if (Array.isArray(history)) {
            this.history = history;
            debugLog(`📝 History restored for Team ${this.teamId}:`, history.length, 'entries');
        }
    }

    /**
     * Set callback for when team wins (reaches 18 points)
     * @param {Function} callback - Called with (teamId) when score >= 18
     */
    setOnWin(callback) {
        this.onWin = callback;
    }

    /**
     * Set callback for when score changes
     * @param {Function} callback - Called with (teamId, newScore) on any change
     */
    setOnScoreChange(callback) {
        this.onScoreChange = callback;
    }

    async addPoints(points) {
        const prevScore = this.score;
        this.score = Math.min(18, this.score + points);

        if (this.score !== prevScore && this.onScoreChange) {
            this.onScoreChange(this.teamId, this.score);
        }

        // Check for win condition - Trigger only once
        if (this.score >= 18 && this.onWin && !this.hasWonGame) {
            this.hasWonGame = true;
            await this.onWin(this.teamId);
        }
    }

    subtractPoints(points) {
        const prevScore = this.score;
        this.score = Math.max(0, this.score - points);

        if (this.score !== prevScore && this.onScoreChange) {
            this.onScoreChange(this.teamId, this.score);
        }
    }

    setScore(score) {
        const prevScore = this.score;
        this.score = Math.max(0, Math.min(18, score));

        if (this.score !== prevScore && this.onScoreChange) {
            this.onScoreChange(this.teamId, this.score);
        }

        // Check for win condition
        if (this.score >= 18 && this.onWin) {
            this.onWin(this.teamId);
        }
    }

    /**
     * Reset score to 0 for a new round
     */
    reset() {
        this.score = 0;
        this.history = []; // Clear history
        this.hasWonGame = false;
        if (this.onScoreChange) {
            this.onScoreChange(this.teamId, this.score);
        }
    }

    /**
     * Returns true if the joker should be face up (score >= 9 and < 18)
     */
    isJokerFaceUp() {
        return this.score >= 9 && this.score < 18;
    }

    /**
     * Returns the number of oros that should be visible (0-8)
     * 0 points: 0 oros visible
     * 1-8 points: 1-8 oros visible
     * 9 points: 0 oros visible (joker flips)
     * 10-17 points: 1-8 oros visible
     * 18 points: 0 oros visible (salida - game won)
     */
    getVisibleOros() {
        if (this.score === 0) return 0;
        if (this.score === 9) return 0;
        if (this.score === 18) return 0; // Salida - treat like 0 or 9
        return this.score % 9;
    }

    /**
     * Returns true if the team has reached 18 points (salida)
     */
    hasSalida() {
        return this.score === 18;
    }

    /**
     * Returns true if the team is in "malas" (score < 9 or score == 18)
     */
    isInMalas() {
        return this.score < 9 || this.score === 18;
    }

    /**
     * Returns true if the team is in "buenas" (score >= 9)
     */
    isInBuenas() {
        return this.score >= 9;
    }
}

export default ScoreMarker;
